var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg6Desktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 600,
    viewBox: "0 0 1400 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_350_100056)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.554,
    cy: 640.358,
    rx: 438.554,
    ry: 640.358,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1314.88 -298.07)",
    fill: "url(#paint0_linear_350_100056)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_350_100056)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.554,
    cy: 640.358,
    rx: 438.554,
    ry: 640.358,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1511.43 -840)",
    fill: "url(#paint1_linear_350_100056)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_350_100056",
    x: 277.539,
    y: -451.682,
    width: 1811.73,
    height: 1870.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 186,
    result: "effect1_foregroundBlur_350_100056"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_350_100056",
    x: 474.094,
    y: -993.611,
    width: 1811.73,
    height: 1870.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 186,
    result: "effect1_foregroundBlur_350_100056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_100056",
    x1: 438.554,
    y1: 0,
    x2: 438.554,
    y2: 1280.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_350_100056",
    x1: 438.554,
    y1: 0,
    x2: 438.554,
    y2: 1280.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg6Desktop);
export default __webpack_public_path__ + "static/media/bg6-desktop.4262797fa21c0367330cd0df4a5e4aa2.svg";
export { ForwardRef as ReactComponent };